export default "<p>Patient Financtial Information Coming soon.</p>\r\n"